<template>
  <div>
    <template v-if="isBool">
      <Row v-for="(item, index) in materialsList" :key="index">
        <div v-if="materialsObj[item.code].length != 0">
          <div class="result-title">[ {{ item.name }} ]</div>
          <div class="result-content clearfix">
            <div
              v-for="(itemSec, indexSec) in materialsObj[item.code]"
              :key="indexSec"
              class="file-block"
            >
              <div class="file-image">
                <div
                  v-if="readOnly"
                  style="cursor: pointer;"
                  @click="handleLinkView(itemSec.attachment)"
                >
                  <i
                    v-if="!readOnly"
                    class="icon-down-01 delete-icon"
                    @click="deteleOne(item.code, indexSec)"
                  ></i>
                  <file-image
                    :media-type="
                      itemSec.attachment ? itemSec.attachment.mediaType : ''
                    "
                    :file-name="
                      itemSec.attachment ? itemSec.attachment.fileName : ''
                    "
                    :size="28"
                  />
                </div>
                <div v-else>
                  <i
                    v-if="!readOnly"
                    class="icon-down-01 delete-icon"
                    @click="deteleOne(item.code, indexSec)"
                  ></i>
                  <file-image
                    :media-type="
                      itemSec.attachment ? itemSec.attachment.mediaType : ''
                    "
                    :file-name="
                      itemSec.attachment ? itemSec.attachment.fileName : ''
                    "
                    :size="28"
                  />
                </div>
              </div>
              <span
                class="textover block-title"
                :title="itemSec.attachment ? itemSec.attachment.fileName : ''"
              >{{
                itemSec.attachment ? itemSec.attachment.fileName : ''
              }}</span>
            </div>
          </div>
        </div>
      </Row>
    </template>

    <Row v-if="materialsObj['upload'].length != 0">
      <div class="result-title">[ 任务附件 ]</div>
      <div class="result-content clearfix">
        <div
          v-for="(itemSec, indexSec) in materialsObj['upload']"
          :key="indexSec"
          class="file-block"
        >
          <div
            v-for="(itemSec, indexSec) in materialsObj['upload']"
            :key="indexSec"
            class="file-block"
          >
            <div class="file-image">
              <div
                v-if="readOnly"
                style="cursor: pointer;"
                @click="handleLinkView(itemSec.attachment)"
              >
                <i
                  v-if="!readOnly"
                  class="icon-down-01 delete-icon"
                  @click="deteleOne('upload', indexSec)"
                ></i>
                <file-image
                  :media-type="
                    itemSec.attachment ? itemSec.attachment.mediaType : ''
                  "
                  :file-name="
                    itemSec.attachment ? itemSec.attachment.fileName : ''
                  "
                  :size="28"
                />
              </div>
              <div v-else>
                <i
                  v-if="!readOnly"
                  class="icon-down-01 delete-icon"
                  @click="deteleOne('upload', indexSec)"
                ></i>
                <file-image
                  :media-type="
                    itemSec.attachment ? itemSec.attachment.mediaType : ''
                  "
                  :file-name="
                    itemSec.attachment ? itemSec.attachment.fileName : ''
                  "
                  :size="28"
                />
              </div>
            </div>
            <span
              class="textover block-title"
              :title="itemSec.attachment ? itemSec.attachment.fileName : ''"
            >{{ itemSec.attachment ? itemSec.attachment.fileName : '' }}</span>
          </div>
        </div>
      </div>
    </Row>

    <preview-file ref="perviewFile" :read-only="true" />
  </div>
</template>
<script>
import fileImage from '@/components/common/fileImage/fileImage'
import JSZip from 'jszip'

export default {
  components: {
    fileImage
  },
  props: ['defaultList', 'readOnly', 'loading'],
  data() {
    return {
      materialsList: [],
      isBool: false
    }
  },
  computed: {
    materialsObj() {
      const obj = {
        upload: []
      }
      this.materialsList.forEach((item, index) => {
        obj[item.code] = []
      })
      return obj
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    this.getMaterialList()
  },
  mounted() {},
  updated() {},
  methods: {
    getMaterialList() {
      const url = '/business/materialTypes'
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.materialsList = res.data
          if (this.defaultList) {
            this.uploadData(this.defaultList)
          }
        }
      })
    },
    uploadData(data) {
      this.isBool = false
      for (const key in this.materialsObj) {
        this.materialsObj[key] = []
      }
      data.forEach((item, index) => {
        if (item.type) {
          this.materialsObj[item.type].push(item)
        } else {
          this.materialsObj['upload'].push(item)
        }
      })
      this.isBool = true
    },
    deteleOne(code, index) {
      this.isBool = false
      this.materialsObj[code].splice(index, 1)
      this.isBool = true
      // 将数据返回给父组件
      const obj = {
        materials: [],
        upload: []
      }
      for (const key in this.materialsObj) {
        if (key != 'upload') {
          obj.materials = obj.materials.concat(this.materialsObj[key])
        } else {
          obj.upload = this.materialsObj['upload']
        }
      }
      this.$emit('getFileList', obj)
    },
    packAll() {
      const fileObj = {}
      Object.keys(this.materialsObj).forEach(key => {
        if (key !== 'upload' && this.materialsObj[key].length > 0) {
          fileObj[
            this.materialsList.find(item => item.code == key).name
          ] = this.materialsObj[key].map(item => {
            return {
              url: item.attachment.url.replace(
                item.attachment.url.match(/.*\//)[0].slice(0, -1),
                ''
              ),
              attachmentId: item.attachmentId,
              fileName: item.attachment.fileName
            }
          })
        }
      })
      console.log('fileObj', fileObj)
      if (Object.keys(fileObj).length <= 0) {
        this.$Message.error('当前任务不存在附件')
      } else {
        this.$emit('update:loading', true)
        const zip = new JSZip()
        let promiseAllNum = 0
        Object.keys(fileObj).forEach(async key => {
          // 添加空文件夹
          const folder = zip.folder(
            key == '在先判决/相关案例' ? '在先判决-相关案例' : key
          )
          const responses = await Promise.all(
            fileObj[key].map(item => this.$getTencentFile(item.url))
          )
          responses.forEach((res, index) => {
            console.log(index, fileObj[key][index].fileName)
            const fileName = fileObj[key][index].fileName
            folder.file(fileName, res.data)
          })

          promiseAllNum += 1
          // 在所有请求结束后，进行后续的操作，如生成压缩包等。
          if (promiseAllNum == Object.keys(fileObj).length) {
            // 生成并下载压缩包
            zip.generateAsync({ type: 'blob' }).then(content => {
              const downloadUrl = window.URL.createObjectURL(content)
              const link = document.createElement('a')
              link.href = downloadUrl
              link.setAttribute(
                'download',
                `${this.$attrs['task-title']}相关附件.zip`
              )
              document.body.appendChild(link)
              link.click()
              // 释放 URL 对象
              URL.revokeObjectURL(link.href)
              this.$emit('update:loading', false)
            })
          }
        })
      }
    },
    // 打开链接
    handleLinkView(item) {
      const arr = ['image', 'sheet', 'ms-excel', 'xlsx', 'xls', 'document', 'msword', 'docx', 'doc', 'powerpoint', 'presentation', 'pdf', 'text/plain', 'txt']
      if (arr.some(value => item.mediaType.includes(value))) {
        // arr里面 是在线预览，其他都打开新窗口
        this.$refs.perviewFile.preview(item)
      } else {
        const url = item.url
        window.open(url, '_blank')
        return
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/globalStyle.scss';
.file-block {
  display: inline-block;
  width: 80px;
  text-align: center;
  .file-image {
    position: relative;
    height: 30px;
    width: 100%;
    .delete-icon {
      font-size: 14px;
      position: absolute;
      top: -3px;
      right: 0px;
      cursor: pointer;
      &:hover {
        color: $errorColor;
      }
    }
  }
  span {
    width: 100%;
    text-align: center;
    line-height: 18px;
  }
  .block-title {
    display: inline-block;
    padding-right: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/taskHall/plugin/materialsInfo/materialsInfo.vue